import { render, staticRenderFns } from "./EditAlarmSetting.vue?vue&type=template&id=0d96788d&scoped=true"
import script from "./EditAlarmSetting.vue?vue&type=script&lang=js"
export * from "./EditAlarmSetting.vue?vue&type=script&lang=js"
import style0 from "./EditAlarmSetting.vue?vue&type=style&index=0&id=0d96788d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96788d",
  null
  
)

export default component.exports